/** 与 Swagger UserCrsTaxInfoReqDTO.taxStatus 一致 */
export const CRS_TAX_STATUS = {
  PROVIDED: 'TIN_PROVIDED',
  NOT_PROVIDED: 'TIN_NOT_PROVIDED',
} as const;

export type CrsTaxStatus = (typeof CRS_TAX_STATUS)[keyof typeof CRS_TAX_STATUS];

/** 与业务/Admin 一致：DRAFT / SUBMITTED / APPROVING / REFUSED / EFFECTIVE */
export const CRS_RECORD_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  APPROVING: 'APPROVING',
  REFUSED: 'REFUSED',
  EFFECTIVE: 'EFFECTIVE',
} as const;

export type CrsRecordStatus = (typeof CRS_RECORD_STATUS)[keyof typeof CRS_RECORD_STATUS];

/** 结果页展示态：审核中（蓝钟）/ 已完成（绿✓）/ 已拒绝（红叹号） */
export const CRS_RESULT_KIND = {
  PENDING: 'pending',
  DONE: 'done',
  REFUSED: 'refused',
} as const;

export type CrsResultKind = (typeof CRS_RESULT_KIND)[keyof typeof CRS_RESULT_KIND];

export const isCrsPendingStatus = (status: string) =>
  status === CRS_RECORD_STATUS.SUBMITTED || status === CRS_RECORD_STATUS.APPROVING;

export const isCrsDoneStatus = (status: string) => status === CRS_RECORD_STATUS.EFFECTIVE;

export const isCrsRefusedStatus = (status: string) => status === CRS_RECORD_STATUS.REFUSED;

export const crsResultKindFromStatus = (status: string): CrsResultKind | null => {
  if (isCrsPendingStatus(status)) return CRS_RESULT_KIND.PENDING;
  if (isCrsDoneStatus(status)) return CRS_RESULT_KIND.DONE;
  if (isCrsRefusedStatus(status)) return CRS_RESULT_KIND.REFUSED;
  return null;
};
